import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "histoire", label: "Histoire" },
  { id: "disciplines", label: "Disciplines" },
  { id: "profs", label: "Profs" },
  { id: "planning", label: "Planning" },
  { id: "compagnie", label: "Compagnie" },
  { id: "projets", label: "Projets" },
  { id: "events", label: "Events" },
  { id: "galerie", label: "Galerie" },
  { id: "actus", label: "Actus" },
];

export function Navbar({ onRegister }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (window.location.pathname !== "/") { window.location.assign(`/#${id}`); return; }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 600);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "glass py-2" : "py-4 bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between">
        <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/logo-ajdr.png" alt="AJDR Factory" className={`rounded-full transition-all duration-500 ${scrolled ? "w-10 h-10" : "w-12 h-12 md:w-14 md:h-14"}`} />
          <span className="flex flex-col leading-none">
            <span className="font-display font-black text-lg md:text-xl tracking-tight text-cream">AJDR<span className="text-mustard">.</span></span>
            <span className="hidden sm:block font-mono2 text-[10px] text-cream/50 tracking-[0.25em] uppercase mt-1">Factory · Albi</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-sub text-sm text-cream/80 hover:text-cream link-underline"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-register-btn"
            onClick={onRegister}
            className="btn-mustard rounded-full px-4 md:px-6 py-2 text-sm"
          >
            S'inscrire
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-cream"
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden glass mt-2 mx-4 rounded-2xl p-4 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-mobile-link-${l.id}`}
              className="text-left font-sub text-cream/90 py-2 px-2 rounded-lg hover:bg-mustard/10"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
